module.exports = __webpack_public_path__ + "static/assets/8a062193779ce87c1c79f9ac307ac681.png";